import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';
import * as Catalogs from 'catalogs/components';

class CatalogsRowContainer extends Component {
  render = () => (
    <Catalogs.Row
      handleToggle={this.props.handleToggle}
      catalog={this.props.catalog}
      company={this.props.company}
      subcompany={this.props.subcompany}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(CatalogsRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/containers/CatalogRowContainer.js